import React from "react";
import {
  IconButton,
  Modal as ModalMui,
  Typography,
  Button,
  Tooltip,
} from "@mui/material";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Box from "@mui/material/Box";
import styles from "./Modal.module.scss";
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { grey } from "@mui/material/colors";

export const Modal = ({
  showBackArrow,
  open,
  onClose,
  children,
  title,
  width,
  height,
  type,
}) => {
  const modalBoxStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ?? 900,
    height: height ?? 600,
    border: "2px solid #000",
    boxShadow: 20,
    backgroundColor: "#ffffff",
    overflowY: "auto",
  };

  const childrenWithProps = React.Children.map(children, (child) => {

    if (React.isValidElement(child)) {
      return React.cloneElement(child, { onClose });
    }
    return child;
  });

  const theme = createTheme({
    palette: {
      primary: grey,
    },
  });

  return (
    <ModalMui open={open} onClose={onClose}>
      <Box style={{ height: "100%" }}>
        <Box sx={modalBoxStyle}>
          <div className={styles.headerModal}>
            {showBackArrow ? (
              <IconButton onClick={onClose} style={{ height: "40px", width: "40px", margin: "10px" }}>
                <ArrowBackIosNewRoundedIcon />
              </IconButton>
            ) : (
              <></>
            )}
            <Typography variant="h5" className={styles.modalTitle}>
              {title}
            </Typography>
            {type !== "farm" ? (
              <Tooltip title="Fechar">
                <div className={styles.closeButton}>
                  <IconButton onClick={onClose}>
                    <CloseRoundedIcon />
                  </IconButton>
                </div>
              </Tooltip>
            ) : (
              <div className={styles.closeButton}>
                <ThemeProvider theme={theme}>
                  <Button
                    onClick={onClose}
                    size="small"
                    sx={{
                      marginTop: "20px",
                      height: "30px",
                      width: "25px",
                      backgroundColor: "#d0d0d0",
                      "&:hover": {
                        backgroundColor: 'gray',
                      },
                    }}
                    startIcon={
                      <CloseRoundedIcon
                        fontSize="small"
                        style={{
                          marginLeft: "10px",
                          fontSize: "22px",
                          color: "#000000",
                        }}
                      />
                    }
                  ></Button>
                </ThemeProvider>
              </div>
            )}
          </div>
          <Box p={2} sx={{ height: '80%' }}>{childrenWithProps}</Box>
        </Box>
      </Box>
    </ModalMui >
  );
};
